export const dieFunc = (item) => {
    const fixedBlock = document.querySelector('.fixed-block-mob');

    if (fixedBlock) {
        item.classList.toggle('active');
        fixedBlock.classList.toggle('open');
        document.body.classList.toggle('over-y-hide');
    }
};